import BaseRestService from "./BaseRestService";

class PanelLibraryService extends BaseRestService {
  async getAllPanels() {
    const url = `/api/v2/library/panel/all`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async createPanel(data) {
    const url = `/api/v2/library/panel/add`;
    return this.client.post(
      url,
      { data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async editPanel(data) {
    const url = `/api/v2/library/panel/edit`;
    return this.client.post(
      url,
      { data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async deletePanel(id) {
    const url = `/api/v2/library/panel/delete`;
    return this.client.post(url, { id }, await this.buildJWTAuthAxiosConfig());
  }
}

export const panelLibraryService = new PanelLibraryService();
